const axios = require('axios');
const config = require('../config');

export const getArticleCount = async (articleId, locale) => {
  const url =
    config &&
    config.recommendedArticle &&
    config.recommendedArticle.getCountUrl
      .replace('[articleId]', articleId)
      .replace('[locale]', locale);
  const response = await axios({
    method: 'get',
    url,
    baseURL:
      config && config.recommendedArticle && config.recommendedArticle.baseUrl,
  });

  return response;
};

export const postArticleCount = data => {
  return new Promise((resolve, reject) => {
    const url = config.recommendedArticle.postCountUrl;
    axios({
      method: 'post',
      url,
      baseURL: config.recommendedArticle.baseUrl,
      data,
    })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
